export default "__VITE_ASSET__B3RtjN3x__"